/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WebsiteWhatsAppCtaSlot } from './WebsiteWhatsAppCtaSlot';
export type PublicSiteWhatsAppClickEventBody = {
    slot: WebsiteWhatsAppCtaSlot;
    propertyId?: number;
    propertyCode?: string;
    propertyName?: string;
    pageUrl?: string;
    targetUrl?: string;
    recaptchaToken?: string;
    recaptchaAction?: PublicSiteWhatsAppClickEventBody.recaptchaAction;
};
export namespace PublicSiteWhatsAppClickEventBody {
    export enum recaptchaAction {
        WHATSAPP_CLICK = 'whatsapp_click',
    }
}

